import { render, staticRenderFns } from "./fccRelatoriosPermissao.vue?vue&type=template&id=2c5fab53"
import script from "./fccRelatoriosPermissao.vue?vue&type=script&lang=js"
export * from "./fccRelatoriosPermissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports